<template>
  <GmbSection
      :displayLevel="1"
      :collapseIsVisibleByDefault="collapseIsVisibleByDefault"
      isCollapsible
      :title="title"
  >
    <template #picto>
      <FdText colorTheme4 fa><i :class="categoryFAPictoCssClasses"/></FdText>
    </template>

    <GmbSection
        v-for="(filter, i) in filterCategory.filters"
        :childCheckboxActivatedValues="
        filterCategory.activatedFilterOptions[filter.slug]
      "
        :childCheckboxAllValues="
        filter.filterOptions.map((filterOption) => filterOption.slug)
      "
        :class="{ 'mt-2': i != 0 }"
        disableSearchForChildControls
        isCollapsible
        :key="i"
        :title="filter.label"
        @child-checkbox-activated-values-changed="
        (newActivatedFilterOptionSlugs) =>
          $emit(
            'filter-activated-options-changed',
            filter.slug,
            newActivatedFilterOptionSlugs
          )
      "
    >
      <template #infoSticker>
        <GmbSticker
            :isAlert="
            filterCategory.activatedFilterOptions[filter.slug].length !==
            filter.filterOptions.length
          "
            :text="
            filterCategory.activatedFilterOptions[filter.slug].length +
            '/' +
            filter.filterOptions.length
          "
        />
      </template>

      <GmbRow
          v-for="(filterOption, j) in filter.filterOptions"
          :class="{ 'mt-2': j != 0 }"
          :controlValue="filterOption.slug"
          isCheckbox
          :key="j"
      >
        <FdText tag="span">{{ filterOption.label }}</FdText>

        <template #infoSticker>
          <GmbIndividualSticker
              :individualCount="
              (filterOption.individualCount != undefined
                ? filterOption.individualCount
                : '?') +
              '/' +
              (filterOption.baseIndividualCount != undefined
                ? filterOption.baseIndividualCount
                : '?')
            "
          />
        </template>
      </GmbRow>
    </GmbSection>
  </GmbSection>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbIndividualSticker from "@/widgets/IndividualSticker";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbSidePanelFilters",

  components: {
    FdText,
    GmbIndividualSticker,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    categoryFAPictoCssClasses: String,
    collapseIsVisibleByDefault: Boolean,
    filterCategory: Object,
    title: String,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
